import React from 'react';

import { Option, Select } from 'carbon-react/lib/components/select';

import * as styles from './empty-select.scss';

export interface EmptySelectProps {
  id: string;
  label: string;
  placeholder: string;
  emptyText: string;
  createText: string;
  onCreateAction: () => void;
  inputHint?: string;
  error?: string;
}

const CREATE_ACTION = '__create_action__';

export const EmptySelect = ({
  id,
  label,
  placeholder,
  emptyText,
  createText,
  onCreateAction,
  inputHint,
  error
}: EmptySelectProps) => (
  <Select
    id={id}
    label={label}
    placeholder={placeholder}
    inputHint={inputHint}
    value=""
    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
      if (e.target.value === CREATE_ACTION) {
        onCreateAction();
      }
    }}
    mb={0}
    error={error}
  >
    <Option
      text={emptyText}
      disabled
      className={styles.emptyStateOption}
    />
    <Option
      value={CREATE_ACTION}
      text={createText}
      className={styles.createActionOption}
    />
  </Select>
);
